function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Icon_map-restaurant",
  "data-name": "Icon map-restaurant",
  d: "M14.855,1.314v7.06H13.579V1.358a.638.638,0,1,0-1.276,0V8.375H11.027V1.335a.639.639,0,0,0-1.276-.021V8.375H8.476V1.364A.638.638,0,0,0,7.2,1.33v9.232A2.406,2.406,0,0,0,9.752,12.77V29.425a1.914,1.914,0,1,0,3.827,0V12.771a2.554,2.554,0,0,0,2.552-2.058V1.335a.64.64,0,0,0-1.276-.02ZM20.6,3.272V19.219h1.276V29.425c0,2.552,4.465,2.552,4.465,0V3.272C26.337.082,20.6.082,20.6,3.272Z",
  transform: "translate(-7.2 -0.72)",
  fill: "#596375",
  opacity: 0.5
});

var SvgIconForkEat = function SvgIconForkEat(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19.137,
    height: 30.619,
    viewBox: "0 0 19.137 30.619",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconForkEat, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-fork-eat.86c7c5cb.svg";
export { ForwardRef as ReactComponent };